import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { ImageWrapper } from './image.styles';

interface Props {
  src?: string;
  alt?: string;
  width: string;
  height: string;
  borderRadius: string;
}

const Image = ({
  src,
  alt,
  width = 'auto',
  height = 'auto',
  borderRadius = '0',
}: Props) => {
  const [isLogoLoaded, setIsLogoLoaded] = useState(false);
  const hasLogo = Boolean(src);
  const showLogoImage = hasLogo && isLogoLoaded;

  return (
    <ImageWrapper
      $width={width}
      $height={height}>
      {!showLogoImage && (
        <Skeleton
          height={height}
          width={width}
          borderRadius={borderRadius}
        />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => setIsLogoLoaded(true)}
        onError={() => setIsLogoLoaded(false)}
        style={{ display: isLogoLoaded ? 'block' : 'none' }}
      />
    </ImageWrapper>
  );
};

export default Image;
